import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-3\" id=\"usage\"><a href=\"#usage\"></a> Usage </h1><div class=\"py-5\"> Use Bootstrap Icons with a spesific class as explained in the <a class=\"fw-bold\" href=\"https://icons.getbootstrap.com/icons/alarm-fill/\" target=\"_blank\">Icons Preview Page</a>: </div><div class=\"py-5\"><div class=\"rounded border d-flex flex-wrap p-10\"><i class=\"bi bi-bookmarks-fill fs-2x me-15\"></i><i class=\"bi bi-calendar-check fs-2x me-15\"></i><i class=\"bi bi-check2-square fs-2x me-15\"></i><i class=\"bi bi-diagram-3 fs-2x me-15\"></i><i class=\"bi bi-gear fs-2x me-15\"></i><i class=\"bi bi-circle-square fs-2x me-15\"></i><i class=\"bi bi-graph-down fs-2x me-15\"></i><i class=\"bi bi-vector-pen fs-2x me-15\"></i></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<i class="bi bi-bookmarks-fill fs-2x"></i>
        <i class="bi bi-calendar-check fs-2x"></i>
        <i class="bi bi-check2-square fs-2x"></i>
        <i class="bi bi-diagram-3 fs-2x"></i>
        <i class="bi bi-gear fs-2x"></i>
        <i class="bi bi-circle-square fs-2x"></i>
        <i class="bi bi-graph-down fs-2x"></i>
        <i class="bi bi-vector-pen fs-2x"></i>`))
        ]),
        _: 1
      })
    ])
  ]))
}